var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.6,
    y: 0.758417,
    width: 22.8,
    height: 22.8,
    rx: 11.4,
    stroke: "#F2F2F2",
    strokeWidth: 1.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2436_481)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0006 7.67578C13.41 6.41038 15.588 6.45238 16.9458 7.81258C18.303 9.17338 18.3498 11.3406 17.0874 12.7542L11.9994 17.8494L6.9126 12.7542C5.6502 11.3406 5.6976 9.16978 7.0542 7.81258C8.4132 6.45418 10.587 6.40858 12.0006 7.67578ZM16.0962 8.66038C15.1962 7.75918 13.7442 7.72258 12.8022 8.56858L12.0012 9.28738L11.1996 8.56918C10.2546 7.72198 8.8056 7.75918 7.9032 8.66158C7.0092 9.55558 6.9642 10.9866 7.788 11.9322L12 16.1508L16.212 11.9328C17.0364 10.9866 16.9914 9.55738 16.0962 8.66038Z",
    fill: "#F2F2F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2436_481"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.4,
    height: 14.4,
    fill: "white",
    transform: "translate(4.80005 4.9584)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHeart);
export default __webpack_public_path__ + "static/media/empty-heart.81e27ba3e37457b609746643caa1efe9.svg";
export { ForwardRef as ReactComponent };